import React, { FC, useEffect, useState } from "react"
import { ArtistTrendEconomy, StreamTrackMonth, TrendTopTrack } from "../../../../types"
import { KSpan, KTitleSpan } from "kahuna-base-react-components"
import NotFound from "../../../NotFound"
import { lang } from "../../../../constants/languages"
import { formatNumber, replaceCurrencies } from "../../../../utility"

type RoyaltyThreeMonthsProps = {
  artistTrendEconomies: ArtistTrendEconomy[]
}

const RoyaltyThreeMonths: FC<RoyaltyThreeMonthsProps> = (props) => {
  const { artistTrendEconomies } = props

  const [hoverId, setHoverId] = useState<number>()

  return (
    <div className="w-full h-full">
      <div
        className="py-5 px-7 min-h-[100%]"
        style={{
          borderRadius: "10px",
          border: "1px solid var(--stroke-soft-200, #F3F3F3)",
          background: "var(--bg-white-0, #FFF)",
          boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)"
        }}
      >
        <div>
          <div className="flex" style={{ width: "100%" }}>
            <div style={{ width: "22%" }}></div>
            <div className="flex justify-center" style={{ width: "39%" }}>
              <KSpan color="#111" text={"Gross / Net / Kahuna Share"} />
            </div>
          </div>
          <div className="flex mb-4" style={{ width: "100%" }}>
            <div style={{ width: "26%" }}>
              <KSpan color="#111" text={"User"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"60–90 days"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"30–60 days"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan color="#111" text={"0-30 days"} />
            </div>
            <div style={{ width: "12%" }}>
              <KSpan color="#111" text={"Sp Unit Price"} />
            </div>
            <div style={{ width: "12%" }}>
              <KSpan color="#111" text={"Gross Unit Price"} />
            </div>
            <div style={{ width: "11%" }}>
              <KSpan color="#111" text={"Net Unit Price"} />
            </div>
          </div>
          {artistTrendEconomies && !(artistTrendEconomies.length > 0) && (
            <div className="flex p-5 w-full justify-center mt-[100px]">
              <NotFound title={lang.not_found.trends.title} description={lang.not_found.trends.desc} imageWidth={400} />
            </div>
          )}
          <div className="flex p-2 mb-3" style={{ width: "100%", background: "#00000008", borderRadius: "5px" }}>
            <div style={{ width: "26%" }}>
              <KSpan fontWeight={600} color="#111" text={"TOTAL"} />
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={`${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount90 || 0), 0) || 0).toFixed(1)
                )}$ / ${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet90 || 0), 0) || 0).toFixed(1)
                )}$`}
              />
              <div className="flex ml-4">
                <KSpan
                  fontWeight={600}
                  color="green"
                  text={`+${formatNumber(
                    (
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount90 || 0), 0) || 0) -
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet90 || 0), 0) || 0)
                    ).toFixed(1)
                  )}$`}
                />
              </div>
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={`${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount60 || 0), 0) || 0).toFixed(1)
                )}$ / ${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet60 || 0), 0) || 0).toFixed(1)
                )}$`}
              />
              <div className="flex ml-4">
                <KSpan
                  fontWeight={600}
                  color="green"
                  text={`+${formatNumber(
                    (
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount60 || 0), 0) || 0) -
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet60 || 0), 0) || 0)
                    ).toFixed(1)
                  )}$`}
                />
              </div>
            </div>
            <div style={{ width: "13%" }}>
              <KSpan
                fontWeight={600}
                color="#111"
                text={`${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount30 || 0), 0) || 0).toFixed(1)
                )}$ / ${formatNumber(
                  (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet30 || 0), 0) || 0).toFixed(1)
                )}$`}
              />
              <div className="flex ml-4">
                <KSpan
                  fontWeight={600}
                  color="green"
                  text={`+${formatNumber(
                    (
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalAmount30 || 0), 0) || 0) -
                      (artistTrendEconomies?.reduce((sum, item) => sum + (item.totalNet30 || 0), 0) || 0)
                    ).toFixed(1)
                  )}$`}
                />
              </div>
            </div>
          </div>
          {artistTrendEconomies?.map((artistTrendEconomy) => {
            console.log(artistTrendEconomy)
            const background = hoverId === artistTrendEconomy.userId ? "#00000008" : "transparent"
            return (
              <div
                className="flex p-2"
                style={{ width: "100%", background, borderRadius: "5px" }}
                key={`trend_top_track_${artistTrendEconomy.userId}}`}
                onMouseOver={() => setHoverId(artistTrendEconomy.userId)}
              >
                <div style={{ width: "26%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px"
                    }}
                  >
                    <img
                      src={artistTrendEconomy?.user?.photo || "/account_icons/avatar.svg"}
                      alt={artistTrendEconomy?.user?.firstName}
                      style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                    />
                    <div>
                      <div>
                        <KTitleSpan
                          fontSize={16}
                          lineHeight="20px"
                          text={`${artistTrendEconomy?.user?.firstName} ${artistTrendEconomy?.user?.lastName}`}
                        />
                      </div>
                      <div>
                        <KSpan fontSize={12} text={artistTrendEconomy?.user?.email} />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "13%" }}>
                  <KSpan
                    text={`${formatNumber((artistTrendEconomy.totalAmount90 || 0).toFixed(1))}$ / ${formatNumber(
                      (artistTrendEconomy.totalNet90 || 0).toFixed(1)
                    )}$`}
                  />
                  <div className="flex ml-4">
                    <KSpan
                      fontWeight={600}
                      color="green"
                      text={`+${formatNumber(
                        (artistTrendEconomy.totalAmount90 - artistTrendEconomy.totalNet90).toFixed(1)
                      )}$`}
                    />
                  </div>
                </div>
                <div style={{ width: "13%" }}>
                  <KSpan
                    text={`${formatNumber((artistTrendEconomy.totalAmount60 || 0).toFixed(1))}$ / ${formatNumber(
                      (artistTrendEconomy.totalNet60 || 0).toFixed(1)
                    )}$`}
                  />
                  <div className="flex ml-4">
                    <KSpan
                      fontWeight={600}
                      color="green"
                      text={`+${formatNumber(
                        (artistTrendEconomy.totalAmount60 - artistTrendEconomy.totalNet60).toFixed(1)
                      )}$`}
                    />
                  </div>
                </div>
                <div style={{ width: "13%" }}>
                  <KSpan
                    text={`${formatNumber((artistTrendEconomy.totalAmount30 || 0).toFixed(1))}$ / ${formatNumber(
                      (artistTrendEconomy.totalNet30 || 0).toFixed(1)
                    )}$`}
                  />
                  <div className="flex ml-4">
                    <KSpan
                      fontWeight={600}
                      color="green"
                      text={`+${formatNumber(
                        (artistTrendEconomy.totalAmount30 - artistTrendEconomy.totalNet30).toFixed(1)
                      )}$`}
                    />
                  </div>
                </div>
                <div style={{ width: "12%" }}>
                  <KSpan
                    color="#111"
                    text={`${artistTrendEconomy.spUnitPrice?.toFixed(5)} ${replaceCurrencies(
                      artistTrendEconomy.currency
                    )}`}
                  />
                </div>
                <div style={{ width: "12%" }}>
                  <KSpan
                    color="#111"
                    text={`${artistTrendEconomy.grossUnitPrice?.toFixed(5)} ${replaceCurrencies(
                      artistTrendEconomy.currency
                    )}`}
                  />
                </div>
                <div style={{ width: "11%" }}>
                  <KSpan
                    color="#111"
                    text={`${artistTrendEconomy.netUnitPrice?.toFixed(5)} ${replaceCurrencies(
                      artistTrendEconomy.currency
                    )}`}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default RoyaltyThreeMonths
